import { getTableColumns } from 'helpers';

const CTEPAgentscolumns = [
  ['agent', 'string', 'Agent', 'left', true],
  ['indHolder', 'string', 'IND Holder', 'left', true],
  ['indNumber', 'string', 'IND #', 'left', true],
  ['nscNumber', 'string', 'NSC #', 'left', true],
  ['leadAgent', 'string', 'Lead', 'left', true],
  ['crossRefFlag', 'string', 'Cross Ref', 'left', true],
  ['commercialInvestigational', 'string', 'Commercial Inves', 'left', true],
  ['pmbDistributed', 'string', 'PMB Dist', 'left', true],
  ['crossRefInd', 'string', 'Cross Ref IND', 'left', true],
  ['status', 'string', 'Status', 'left', true],
  ['statusDate', 'date', 'Status Date', 'left', true]
];


export default getTableColumns(CTEPAgentscolumns);
